'use strict';

angular.module('licensure.services')
    .factory('DataSets', ['$http', '$q', function ($http, $q) {
        return {
            get: function (license_id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/datasets', {
                    params: {
                        license_id: license_id
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getForInspection: function (entityId) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/InspectionDatasets', {
                    params: {
                        entityId: entityId
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response);
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;